import { ExternalLinkAlt, P } from '@styled-icons/fa-solid';
import DataTable from '../DataTable';
import { ShowIf } from '../Security/security';
import OverLayWrapper from '../Overlay';

const OrderFormTable = ({
  dth,
  data,
  updateData,
  setPaginationLoaded,
  persist,
  setPersist,
  lastUpdated,
  setNewOrderForm,
}) => {
  const columns = [
    {
      colKey: 'route',
      header: 'Route',
      searchOpts: { type: 'text', sendAs: 'orderFormRoute' },
      fixedWidth: '10%',
    },
    {
      colKey: 'customerEori',
      header: 'Customer',
      searchOpts: { type: 'text', sendAs: 'customerEori' },
      fixedWidth: '15%',
    },
    {
      colKey: 'consignorEori',
      header: 'Consignor',
      searchOpts: { type: 'text', sendAs: 'consignorEori' },
      fixedWidth: '15%',
    },
    {
      colKey: 'consigneeEori',
      header: 'Consignee',
      searchOpts: { type: 'text', sendAs: 'consigneeEori' },
      fixedWidth: '15%',
    },
    {
      colKey: 'exitPort',
      header: 'Exit Port',
      searchOpts: { type: 'text', sendAs: 'exitPort' },
      fixedWidth: '10%',
    },
    {
      colKey: 'entryPort',
      header: 'Entry Port',
      searchOpts: { type: 'text', sendAs: 'entryPort' },
      fixedWidth: '10%',
    },
    {
      colKey: 'shippingStatus',
      header: 'Status',
      searchOpts: { type: 'text', sendAs: 'shippingStatus' },
      fixedWidth: '10%',
    },
    {
      colKey: 'portModel',
      header: 'Port Model',
      searchOpts: { type: 'text', sendAs: 'portModel' },
      fixedWidth: '10%',
    },
    {
      colKey: 'incoterms',
      header: 'Incoterms',
      searchOpts: { type: 'text', sendAs: 'incoterms' },
      fixedWidth: '10%',
    },
    {
      colKey: 'controlled',
      header: 'Controlled',
      searchOpts: { type: 'text', sendAs: 'controlled' },
      fixedWidth: '10%',
    },
  ];

  const renderColumns = () => {
    return data ? (
      columns.map((col) => (
        <DataTable.Column
          key={col.colKey}
          colKey={col?.colKey}
          header={col.header}
          searchOpts={col.searchOpts}
          fixedWidth={col.fixedWidth}
        />
      ))
    ) : (
      <></>
    );
  };

  const renderButton = () => {
    return (
      <DataTable.Column
        className="p-0"
        style={{ height: '1px' }}
        header="View"
        headerStyle={{ textAlign: 'center' }}
        fixedWidth={'5%'}
      >
        {(item) => (
          <OverLayWrapper
            placement="left"
            popoverContent={
              <ul style={{ paddingLeft: '1.2em', margin: 0 }}>
                <li>Exit Port Process 1: {item?.exitPortProcess1 ? 'Yes' : 'No'}</li>
                <li>ENS: {item?.ens ? 'Yes' : 'No'}</li>
                <li>GB Import Entry: {item?.gbImportEntry ? 'Yes' : 'No'}</li>
                <li>FFD: {item?.ffd ? 'Yes' : 'No'}</li>
                <li>Entry Port Process 1: {item?.entryPortProcess1 ? 'Yes' : 'No'}</li>
                <li>TRACES / IPAFFS {item?.tracesOrIpaffs ? 'Yes' : 'No'}</li>
                <li>EAD: {item?.ead ? 'Yes' : 'No'}</li>
                <li>EU Import Entry: {item?.euImportEntry ? 'Yes' : 'No'}</li>
                <li>Valuation Method: {item?.valuationMethod || 'N/A'}</li>
                <li>Valuation DocType: {item?.valuationDocType || 'N/A'}</li>
                <li>Valuation Indicator: {item?.valuationIndicator || 'N/A'}</li>
                <li>Description: {item?.description || ''}</li>
                <li>Job Notes: {item?.jobNotes || ''}</li>
              </ul>
            }
            popoverStyle={{ minWidth: '12rem', padding: '0.5rem' }}
          >
            <button className="external-table-link">
              <ExternalLinkAlt width="1.1rem" height="1.1rem" color="#00857d" />
            </button>
          </OverLayWrapper>
        )}
      </DataTable.Column>
    );
  };

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'auto auto' }}>
        <h1 className="floating-box-header-general">Order Form Rules</h1>
        <p className="floating-box-header-general" style={{ fontSize: '1rem', alignItems: 'end', marginRight: '15px' }}>
          Last Updated: {lastUpdated}
        </p>
      </div>

      <div className="px-3 pt-4">
        <DataTable
          handle={dth}
          lazyLoading
          filterable
          sortable
          data={data}
          className="table-striped fixed-table-size"
          advancedSearch
          showAdvnSearch={true}
          onUpdate={updateData}
          onPaginationLoaded={() => {
            setPaginationLoaded(true);
          }}
          persistGetter={persist}
          persistSetter={setPersist}
        >
          <DataTable.Head>
            <ShowIf
              or={[
                { department: 'OPS', role: 'SUPERUSER' },
                { department: 'QA', role: 'SUPERUSER' },
                { department: 'CMT' },
              ]}
            >
              <section className="d-flex justify-content-end datatable-button">
                <button
                  type="button"
                  className="stepper-button yellow"
                  onClick={() => {
                    setNewOrderForm({});
                  }}
                >
                  Upload
                </button>
              </section>
            </ShowIf>
          </DataTable.Head>
          <DataTable.Pagination itemsPerPage={[10, 25, 50]} areaPadding={'0px'} />
          {renderColumns()}
          {renderButton()}
        </DataTable>
      </div>
    </>
  );
};

export default OrderFormTable;
